import { Card, CardContent, Badge } from '../ui';
interface Opp { id: string; name: string; pipeline_name: string; stage_name: string; monetary_value: number | null; status: string | null; contact_name: string | null; }
const money = (n: number | null) => (n == null ? '-' : n.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }));

export default function OpportunityTable({ opps, loading, onRow, sortBy, sortDir, onSort }: {
  opps: Opp[]; loading: boolean; onRow: (id: string) => void;
  sortBy: string; sortDir: 'asc' | 'desc'; onSort: (c: string) => void;
}) {
  const arrow = (c: string) => (sortBy === c ? (sortDir === 'asc' ? ' ▲' : ' ▼') : '');
  return (
    <Card><CardContent className="p-0">
      {loading ? <div className="text-center py-12 text-gray-500">Loading...</div>
        : opps.length === 0 ? <div className="text-center py-12 text-gray-500">No opportunities found</div>
        : (
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead className="bg-gray-50 border-b"><tr>
            <th className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:text-primary-600" onClick={() => onSort('name')}>Name{arrow('name')}</th>
            <th className="px-4 py-3 text-left font-medium text-gray-700">Stage</th>
            <th className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:text-primary-600" onClick={() => onSort('monetary_value')}>Value{arrow('monetary_value')}</th>
            <th className="px-4 py-3 text-left font-medium text-gray-700 cursor-pointer hover:text-primary-600" onClick={() => onSort('status')}>Status{arrow('status')}</th>
            <th className="px-4 py-3 text-left font-medium text-gray-700">Contact</th>
          </tr></thead>
          <tbody className="divide-y divide-gray-200">
            {opps.map((o) => (
              <tr key={o.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => onRow(o.id)}>
                <td className="px-4 py-3 font-medium text-gray-900">{o.name || '-'}</td>
                <td className="px-4 py-3 text-gray-600">{o.stage_name}</td>
                <td className="px-4 py-3 text-gray-900">{money(o.monetary_value)}</td>
                <td className="px-4 py-3"><Badge>{o.status || '-'}</Badge></td>
                <td className="px-4 py-3 text-gray-600">{o.contact_name || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table></div>
      )}
    </CardContent></Card>
  );
}
